"use client";

import { createContext } from "react";
import type {
  WebSocketChannel as MessageWebSocketChannel,
  WebSocketMessage,
} from "../types";

export type WebSocketSendMessageCallback = (
  channel: MessageWebSocketChannel,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  message: any,
) => void;

export type WebSocketRegisterListenerCallback = <
  T extends WebSocketMessage = WebSocketMessage,
>(
  channel: MessageWebSocketChannel,
  id: string,
  handler: WebSocketListenerHandler<T>,
) => void;

export type WebSocketListenerHandler<
  T extends WebSocketMessage = WebSocketMessage,
> = (message: T) => void;

export type WebSocketDeregisterListenerCallback = (
  channel: MessageWebSocketChannel,
  id: string,
) => void;

export type WebSocketContextState = {
  isConnected: boolean;
  hasConnectionFailed: boolean;
  isWaitingForAgentResponse: boolean;
  sendMessage: WebSocketSendMessageCallback;
  registerListener: WebSocketRegisterListenerCallback;
  deregisterListener: WebSocketDeregisterListenerCallback;
  stopWaiting: () => void;
};

export const WebSocketContext = createContext<
  WebSocketContextState | undefined
>(undefined);
